import {Injectable} from '@angular/core';
import {ApiUrlConstants} from '@coreconstant';
import {HttpService, httpConfig} from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class NewsletterService {

    baseUrlApi = ApiUrlConstants.NEWSLETTER_BASE_URL;
    httpConfig: httpConfig;

    constructor(
        private _httpService: HttpService
    ) {
    }

    /**
     * Sends a subscription request for newsletters using the provided input data.
     * @param {any} input The data to be sent in the subscription request.
     */
    newslettersSubscription(input: any) {
        this.httpConfig = {
            url: this.baseUrlApi,
            method: 'post',
            data: input
        }
        return this._httpService.init(this.httpConfig);
    }
}
